
import React, { createContext, useState, useContext } from "react";
import axios from "axios";
import { signupAPI, servingZipcodeAPI, loginAPI, logoutAPI, forgotPasswordAPI, resetPasswordAPI } from './../api-services/Signup.service'




import { API_NETWORK_ERROR, localStorageKeys } from "../../utils/constants";
import { GlobalStateDataContext } from "./GlobalStateDataProvider";
import IdleJs from "idle-js";

export const SignUpDataContext = createContext();
const SignUpDataProvider = ({ children }) => {
    const { REFRESH_TOKEN, TOKEN } = localStorageKeys;
    const { isLoggedIn, setIsLoggedIn } = useContext(GlobalStateDataContext)

    const [signupAPIResponse, setSignupAPIResponse] = useState({
        loading: false,
        success: null,
        message: null,
        data: null,
    });

    const [servingZipcodeAPIResponse, setServingZipcodeAPIResponse] = useState({
        loading: false,
        success: null,
        message: null,
        data: null,
    });

    const [loginAPIResponse, setLoginAPIResponse] = useState({
        loading: false,
        success: null,
        message: null,
        data: null,
    });

    const [forgotPasswordData, setForgotPasswordData] = useState({
        loading: false,
        success: null,
        message: null,
        data: null,
    });

    const [resetPasswordData, setResetPasswordData] = useState({
        loading: false,
        data: null,
        success: null,
        errorMessage: '',
    });
    const [showIdealPopup, setShowIdealPopup] = useState(false);


    const idle = new IdleJs({
        idle: 10000, // popup will come in 10 mins when idle 600000 ms
        events: ['mousemove', 'keydown', 'mousedown', 'touchstart'], // events that will trigger the idle resetter
        onIdle: function () {
            setShowIdealPopup(true);
        }, // callback function to be executed after idle time
        onActive: function () { }, // callback function to be executed after back form idleness
        onHide: function () { }, // callback function to be executed when window become hidden
        onShow: function () { }, // callback function to be executed when window become visible
        keepTracking: true, // set it to false if you want to be notified only on the first idleness change
        startAtIdle: false, // set it to true if you want to start in the idle state
    });




    const onSignUp = async (payload) => {
        try {
            await setSignupAPIResponse({
                loading: true,
                success: null,
                message: null,
                data: null,
            });

            const data = await signupAPI(payload);


            if (data.hasError) {
                await setSignupAPIResponse({
                    loading: false,
                    data: null,
                    success: !data.hasError,
                    message: data.message
                });
                return
            }

            if (data.data?.success) {
                await setSignupAPIResponse({
                    loading: false,
                    data: data,
                    success: data.data?.success,
                    message: data.data?.CustomMessage,

                });



            } else {
                await setSignupAPIResponse({
                    loading: false,
                    data: data,
                    success: data.data?.success,
                    // message: data.data?.errors[0]?.CustomMessage || data.data?.CustomMessage,
                    message: data.data?.CustomMessage || 'Backend Validation errors',
                });
            }
            return;
        } catch (error) {
            console.log('---Catch black onSignup', error)
            setSignupAPIResponse({ loading: false, data: null, success: false, message: error, })

        }
    };


    const onServingZipcode = async (zipcode) => {
        try {
            await setServingZipcodeAPIResponse({
                loading: true,
                success: null,
                message: null,
                data: null,
            });

            const data = await servingZipcodeAPI(zipcode);

            if (data.hasError) {
                await setServingZipcodeAPIResponse({
                    loading: false,
                    data: null,
                    success: !data.hasError,
                    message: data.message
                });
                return
            }

            if (data?.data?.success) {
                await setServingZipcodeAPIResponse({
                    loading: false,
                    data: data,
                    success: data.data?.success,
                    message: data.data?.CustomMessage

                });

            } else {
                await setServingZipcodeAPIResponse({
                    loading: false,
                    data: data,
                    success: data.data?.success,
                    // message: data.data?.errors[0]?.CustomMessage || data.data?.CustomMessage,
                    message: (data.data?.ErrorMessage || data.data?.message) || 'Validation errors',
                });
            }
            return;
        } catch (error) {
            console.log('---Catch black onServingZipcode', error)
            setServingZipcodeAPIResponse({ loading: false, data: null, success: false, message: error, })

        }
    };


    const onLogin = async (payload) => {
        try {
            await setLoginAPIResponse({
                loading: true,
                success: null,
                message: null,
                data: null,
            });



            const data = await loginAPI(payload);

            if (data.hasError) {
                await setLoginAPIResponse({
                    loading: false,
                    data: null,
                    success: !data.hasError,
                    message: data.message?.CustomMessage,
                });
                return
            }

            if (data.data?.success) {
                await setLoginAPIResponse({
                    loading: false,
                    data: data,
                    success: data.data?.success,
                    message: data.data?.CustomMessage,

                });

                localStorage.setItem(REFRESH_TOKEN, data?.data?.refresh_token);
                localStorage.setItem(TOKEN, data?.data?.token);
                setIsLoggedIn(true)
                idle.start()
                return { loginAPIResponse: data }

            } else {
                await setLoginAPIResponse({
                    loading: false,
                    data: null,
                    success: data.data?.success,
                    message: data.data?.errors?.CustomMessage,
                });
            }
            return;
        } catch (error) {
            console.log('---Catch black onLogin', error)
            setLoginAPIResponse({ loading: false, data: null, success: false, message: error, })

        }
    };


    const onLogout = async () => {
        try {
            const gettingToken = () => localStorage.getItem(TOKEN);
            if (gettingToken()) {
                axios.defaults.headers.common.Authorization = `Bearer ${gettingToken()}`
            }

            const logoutResop = await logoutAPI()
            if (logoutResop) {
                localStorage.clear();
                await setIsLoggedIn(false);
                idle.stop();
                return
            }

        } catch (error) {
            console.log('---Catch block onLogout', error)
        }
    }




    const onForgotPassword = async (payload) => {

        try {
            await setForgotPasswordData({
                loading: true,
                success: null,
                message: null,
                data: null,
            });
            const data = await forgotPasswordAPI(payload);
            if (data.hasError) {
                await setForgotPasswordData({
                    loading: false,
                    data: null,
                    success: !data.hasError,
                    message: data.message,
                });
                return
            }

            if (data.data?.success) {
                await setForgotPasswordData({
                    loading: false,
                    data: data,
                    success: data.data?.success,
                    message: data.data?.CustomMessage,

                });

                return { forgotAPIResponse: data }

            } else {
                await setForgotPasswordData({
                    loading: false,
                    data: null,
                    success: data?.data?.success,
                    message: data.data?.CustomMessage,
                });
            }
            return;
        } catch (error) {
            console.log('---Catch black onLogin', error)
            setForgotPasswordData({ loading: false, data: null, success: false, message: error, })

        }


    };



    const onResetPassword = async (token, payload) => {
        try {
            await setResetPasswordData({
                loading: true,
                success: null,
                data: null,
                errorMessage: '',
            });

            const data = await resetPasswordAPI(token, payload);

            if (data.hasError) {
                await setResetPasswordData({
                    loading: false,
                    data: null,
                    success: !data.hasError,
                    errorMessage: data.message
                });
                return
            }

            if (data.data.success) {
                await setResetPasswordData({
                    loading: false,
                    data: data,
                    success: true,
                    errorMessage: '',

                });

            } else {
                await setResetPasswordData({
                    loading: false,
                    data: data,
                    success: data?.data?.success,
                    errorMessage: data?.data?.CustomMessage
                });
            }

        } catch (error) {
            console.log('---Catch black onResetPassword', error)
            setResetPasswordData({ loading: false, data: null, success: false, errorMessage: error, })

        }
    };


    return (

        <SignUpDataContext.Provider
            value={{
                signupAPIResponse,
                setSignupAPIResponse,
                onSignUp,
                onServingZipcode,
                setServingZipcodeAPIResponse,
                servingZipcodeAPIResponse,
                setLoginAPIResponse,
                onLogin,
                loginAPIResponse,
                onLogout,
                forgotPasswordData, setForgotPasswordData,
                onForgotPassword,
                resetPasswordData, setResetPasswordData,
                onResetPassword,
                idle,
                showIdealPopup, setShowIdealPopup
            }}
        >
            {children}
        </SignUpDataContext.Provider>
    )


}

export default SignUpDataProvider;
